import React from "react";
import { ChartMainCard } from "./ChartsHeader";
import { TeamAvailability } from "./StatCardIcons";
import DataNotFound from "../ui/loader/data-not-found";
import InnerLoader from "../ui/loader/inner-loader";
import Trophy1Icon from "../icons/trophy-1";

const BRAND_COLORS = [
  "#6366F1", // Indigo
  "#22C55E", // Green
  "#F59E0B", // Amber
  "#EF4444", // Red
  "#06B6D4", // Cyan
  "#8B5CF6", // Violet
  "#EC4899", // Pink
  "#14B8A6", // Teal
  "#F97316", // Orange
  "#3B82F6", // Blue
];

// const BRAND_COLORS = [
//   "#5B6EE1", // Soft Indigo
//   "#34C38F", // Medium Emerald
//   "#F7B84B", // Soft Amber
//   "#F46A6A", // Coral Red
//   "#50A5F1", // Sky Blue
//   "#A277FF", // Soft Purple
//   "#FF8DC7", // Muted Pink
//   "#3FC1C9", // Aqua Teal
//   "#FF9F68", // Soft Orange
//   "#4D96FF", // Clean Blue
// ];

// const BrandBar = ({ dept, maxCount = 0 }) => {
//   const count = dept?.deal_count || 0;
//   const totalDeals = maxCount || dept?.total_deal_count || 1;

//   const widthPercent = totalDeals ? (count / totalDeals) * 100 : 0;

//   const percentage = totalDeals ? ((count / totalDeals) * 100).toFixed(1) : 0;

//   return (
//     <div className="py-3 border-b border-slate-100 hover:bg-slate-50 transition-colors duration-150 cursor-pointer">
//       {/* Top Row */}
//       <div className="flex items-center justify-between mb-2">
//         <div className="flex items-center gap-2.5">
//           <div className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-xs font-bold text-slate-700">
//             {dept?.initials}
//           </div>

//           <span className="text-[13px] font-semibold text-slate-900">
//             {dept?.brand_name}
//           </span>
//         </div>

//         <div className="flex items-center gap-4">
//           <span className="text-sm font-bold text-slate-900">{count}</span>

//           <span className="text-[11px] text-slate-400 font-semibold min-w-[45px] text-right">
//             {percentage}%
//           </span>

//           <span className="text-[12px] font-semibold text-emerald-600">
//             {dept?.total_amount}
//           </span>
//         </div>
//       </div>

//       {/* Progress Bar */}
//       <div className="w-full h-1.5 bg-slate-100 rounded-md overflow-hidden">
//         <div
//           className="h-full rounded-md transition-all duration-500 ease-in-out bg-emerald-500"
//           style={{ width: `${widthPercent}%` }}
//         />
//       </div>
//     </div>
//   );
// };

const BrandBar = ({ dept, maxCount = 0, index = 0 }) => {
  const count = dept?.deal_count || 0;
  const widthPercent = (count / maxCount) * 100;
  const percentage = maxCount ? ((count / maxCount) * 100).toFixed(1) : 0;

  const brandColor = BRAND_COLORS[index % BRAND_COLORS.length];

  return (
    <div className="group py-3 border-b border-slate-100 hover:bg-slate-50 transition-all duration-200 cursor-pointer">
      {/* Top Row */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-3">
          {/* Initials Badge */}
          <div
            className="w-9 h-9 flex items-center justify-center rounded-xl text-xs font-bold text-white shadow-sm transition-transform duration-200 group-hover:scale-105"
            style={{ backgroundColor: brandColor }}
          >
            {dept?.initials}
          </div>

          <span className="text-[13px] font-semibold text-slate-900">
            {dept?.brand_name}
          </span>
        </div>

        <div className="flex items-center gap-4">
          <span className="text-sm font-bold text-slate-900">{count}</span>

          <span className="text-[11px] text-slate-400 font-semibold min-w-[45px] text-right">
            {percentage}%
          </span>

          <span
            className="text-[12px] font-semibold"
            style={{ color: brandColor }}
          >
            {dept?.total_amount}
          </span>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full h-[6px] bg-slate-100 rounded-lg overflow-hidden">
        <div
          className="h-full rounded-lg transition-all duration-700 ease-out"
          style={{
            width: `${widthPercent}%`,
            backgroundColor: brandColor,
          }}
        />
      </div>
    </div>
  );
};

const LeadsByBrands = ({ brandData = [], brandLoading }) => {
  return (
    <ChartMainCard
      className={"col-span-4"}
      Icon={<Trophy1Icon />}
      iconColor={"bg-theme-green-light text-theme-green"}
      heading="Brands Performance Overview"
      subHeading={"Leads aquistation breakdown by brand category"}
    >
      {brandLoading ? (
        <InnerLoader />
      ) : (
        <div className="p-0">
          {brandData.length > 0 ? (
            <div className="max-h-[460px] overflow-y-auto px-7">
              {brandData?.map((item, index) => {
                const maxCount = brandData?.reduce(
                  (acc, d) => acc + (d.deal_count || 0),
                  0,
                );

                return (
                  <BrandBar
                    key={item.brand_name}
                    dept={item}
                    maxCount={maxCount}
                    index={index}
                  />
                );
              })}
            </div>
          ) : (
            <div className="flex items-center justify-center h-full">
              <DataNotFound title={"Brands"} />
            </div>
          )}
        </div>
      )}
    </ChartMainCard>
  );
};

export default LeadsByBrands;
